import { GenericSelectModalProps } from './GenericSelectModal';
import { openModal } from '@core/components/ModalStack';

export async function openGenericSelectModal(props: GenericSelectModalProps) {
  const { GenericSelectModal } = await import('./GenericSelectModal');

  openModal(GenericSelectModal, props, { id: 'generic', name: 'generic' });
}
